"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAttrProps = exports.Tab = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Tab = require("./Tab.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var getAttrProps = function getAttrProps(index) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tab';
  return {
    id: "".concat(name, "-").concat(index),
    'aria-controls': "".concat(name, "-panel-").concat(index)
  };
};
exports.getAttrProps = getAttrProps;
var Tab = function Tab(props) {
  var _useStyles = (0, _Tab.useStyles)(),
    root = _useStyles.root,
    selected = _useStyles.selected;
  return /*#__PURE__*/_react["default"].createElement(_core.Tab, _extends({
    classes: {
      root: root,
      selected: selected
    },
    disableRipple: true
  }, props));
};
exports.Tab = Tab;